/**
 * Injects the SVG icons sprite into the document once so that
 * <use href="#s_ar2_r"> etc. work without using a data: or external URL.
 * Avoids "Unsafe attempt to load URL" in Next.js when the sprite would
 * otherwise be bundled as data:image/svg+xml.
 */

import iconsSvg from '../assets/icons.svg?raw'

const SPRITE_CONTAINER_ID = 'medante-icons-sprite'

let injected = false

export function ensureIconsSpriteInjected(): void {
	if (typeof document === 'undefined') return
	if (injected) return
	if (document.getElementById(SPRITE_CONTAINER_ID)) {
		injected = true
		return
	}
	const container = document.createElement('div')
	container.id = SPRITE_CONTAINER_ID
	container.setAttribute('aria-hidden', 'true')
	container.style.cssText =
		'position:absolute;left:-9999px;width:0;height:0;overflow:hidden;pointer-events:none;'
	container.innerHTML = iconsSvg
	document.body.appendChild(container)
	injected = true
}
